import { ReactNode } from 'react';
import { Box, Paper, Typography, Container } from '@mui/material';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  logo?: string;
  logoAlt?: string;
}

export function AuthLayout({ children, title, subtitle, logo, logoAlt = 'Logo' }: AuthLayoutProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {logo && (
            <Box
              component="img"
              src={logo}
              alt={logoAlt}
              sx={{
                width: 140,
                height: 'auto',
                mb: 2,
              }}
            />
          )}
          <Typography component="h1" variant="h5" fontWeight={600} gutterBottom>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" textAlign="center" mb={3}>
              {subtitle}
            </Typography>
          )}
          <Box sx={{ width: '100%', mt: 1 }}>
            {children}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
